export const createLinearMap = (A, B, a, b) => (value) => (value - A) * (b - a) / (B - A) + a



// WEBPACK FOOTER //
// ./src/utility/linearMap.js